// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "upload-app-93bb4.firebaseapp.com",
  projectId: "upload-app-93bb4",
  storageBucket: "upload-app-93bb4.appspot.app", //upload-app-93bb4.firebasestorage.app
  messagingSenderId: "158805671241",
  appId: "1:158805671241:web:1984ef61619f34cb5a6e98",
  measurementId: "G-LDKG0DXGFY"
};


// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);

